import {BaseModel} from "./base-model";
import {Personnel} from "./personnel";
import {Skill, SkillLevel} from './skill';

export class MaintenanceRecommendations extends BaseModel {

  protected static self = MaintenanceRecommendations;

  modality: string;
  fieldWorkers: MaintenanceFieldWorkerRecommendation[];
  remoteExperts: MaintenanceRemoteExpertRecommendation[];

}

export class MaintenanceFieldWorkerRecommendation extends BaseModel {

  protected static self = MaintenanceFieldWorkerRecommendation;

  userSkill: {
    user: Personnel,
    skill: Skill,
    skillLevel: SkillLevel,
    startAt: number,
    expiringAt: number
  };
  hasRequiredLevel: boolean;

  constructor() {
    super();
    this.userSkill.user = new Personnel();
    this.userSkill.skill = new Skill();
    this.userSkill.skillLevel = new SkillLevel();
  }

}

export class MaintenanceRemoteExpertRecommendation extends BaseModel {

  protected static self = MaintenanceRemoteExpertRecommendation;

  user: Personnel;
  skill: Skill;
  skillLevel: SkillLevel;
  expiringAt: number;

  constructor() {
    super();
    this.user = new Personnel();
    this.skill = new Skill();
    this.skillLevel = new SkillLevel();
  }

}
